import { useEffect } from "react";
import { IHook } from "./gameLoss.types";

export const useGameLoss: IHook = ({ showModal }) => {
  useEffect(() => {
    if (!showModal) {
      return;
    }

    showModal();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
